/*

provides an interface for setting/getting utm parameters

This info is gathered in gatsby's onPreRouteUpdate browser API (gatsby-browser.js)

And later used in our API calls (services)

*/

import sessionStorageWrapper from 'util/SessionStorageWrapper'

const paramteterKeys = [
  'utm_source', 
  'utm_medium', 
  'utm_campaign', 
  'utm_term', 
  'utm_content',
  'transaction_id'    // from hasoffers
]

export const injestParameters = (search) => {

  try {
    const params = new URLSearchParams(search);

    paramteterKeys.forEach((key) => {
      const value = params.get(key);
      if (value) {
        sessionStorageWrapper.setItem(key,value)
      }
    })
  
  } catch (e) {
    console.error(e)
  }

}

/*
returns everything we're keeping track of in an object/map
*/
export const getParameters = () => {

  let result = {}
  try {

    paramteterKeys.forEach((key) => {
      const value = sessionStorageWrapper.getItem(key);
        result[key] = value
      })
  
  } catch (e) {
    console.error(e)
  }

  return result
}